import shippingServiceModalHtml from './shippingServiceModal.component.html';

class ShippingServiceModalController {
    constructor($scope, ShippingServiceService) {
        'ngInject';

        this.$scope = $scope;
        this.service = ShippingServiceService;
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }

    onSent() {
        // this.close();
    }
}

let shippingServiceModalComponent = {
    bindings: {},
    template: shippingServiceModalHtml,
    controller: ShippingServiceModalController
};

export default shippingServiceModalComponent;